import { render } from "./AutomationWizardForm.vue?vue&type=template&id=3c97d217&scoped=true"
import script from "./AutomationWizardForm.vue?vue&type=script&lang=js"
export * from "./AutomationWizardForm.vue?vue&type=script&lang=js"

import "./AutomationWizardForm.vue?vue&type=style&index=0&id=3c97d217&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c97d217"]])

export default __exports__